import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import {
  IonButton,
  IonContent,
  IonPage,
} from "@ionic/react";

import "./../../../theme/theme-consumer17.css";
import {
  adjustBackgroundHeight,
  getQrCodeInfo,
} from "../../../common/common";

const QR17ChobaniLanding: React.FC = () => {
  const history = useHistory();
  const contentRef = useRef<HTMLIonContentElement>(null);
  const [qrDetails, setQrDetails] = useState<any>();

  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  };

  useEffect(() => {
    populateQrCodeInfo();
  }, []);

  const handleStartSurvey = () => {
    history.push("/QR17ChobaniSignup");
  };

  return (
    <IonPage>
      <IonContent ref={contentRef} className={`lay__container--${qrDetails?.eventQrId} talent-signup-container`}>
        {typeof qrDetails != 'undefined' && 
          <div className={`lay__talent-signup--${qrDetails?.eventQrId} talent-signup`} style={{paddingBottom: '18px', height: 'auto', maxWidth: '420px', margin: '0 auto'}}>

            <section className="mobile talent-signup__section">

              <div className="lay__background">
                <img src="https://pulseqr.b-cdn.net/qr17Chobani/Background--no-logo.png" alt="Background" />
              </div>

              <div className={`lay__content--${qrDetails?.eventQrId}`} style={{height: '100%', paddingBottom: '0'}}>
                <div className="lay__logo">
                  <div className="">
                    <img style={{paddingTop: '0', marginTop: '0', marginBottom: '25px'}} src="https://pulseqr.b-cdn.net/qr17Chobani/logo.png" alt="Chobani" />
                  </div>
                </div>

                <div className="lay__berry-wrapper" style={{position: 'relative'}}>
                  <img className="lay__berry lay__berry--tl" src="https://pulseqr.b-cdn.net/qr17Chobani/p0-b1.png" alt="" style={{position: 'absolute', top: '10%', left: '-20px', width: '60px'}} />
                  <img className="lay__berry lay__berry--tr" src="https://pulseqr.b-cdn.net/qr17Chobani/p0-b2.png" alt="" style={{position: 'absolute', top: '25%', right: '-20px', width: '60px'}} />
                  <div className="img__first" style={{marginLeft: 'auto', marginRight: 'auto', marginBottom: '20px', zIndex: 10}}>
                    <div className="">
                      <img src="https://pulseqr.b-cdn.net/qr17Chobani/p0-img1.png" alt="Win a $50 gift card" />
                    </div>
                  </div>
                </div>

                <div className="lay__berry-wrapper" style={{position: 'relative'}}>
                  <img className="lay__berry lay__berry--bl" src="https://pulseqr.b-cdn.net/qr17Chobani/p0-b3.png" alt="" style={{position: 'absolute', top: '0', left: '-15px', width: '60px'}} />
                  <img className="lay__berry lay__berry--br" src="https://pulseqr.b-cdn.net/qr17Chobani/p0-b4.png" alt="" style={{position: 'absolute', bottom: '0', right: '-15px', width: '60px'}} />
                  <IonButton
                    expand="block"
                    mode="ios"
                    className="form__submit-img"
                    onClick={handleStartSurvey}
                  >
                    <img src="https://pulseqr.b-cdn.net/qr17Chobani/CTA-Submit0.png" alt="Start Survey" />
                  </IonButton>
                </div>

                
              </div>
              <div className="img__inline" style={{margin: '0', maxWidth: '100%', overflow: 'hidden'}}>
                  <img src="https://pulseqr.b-cdn.net/qr17Chobani/p0-bottom.png" alt="Chobani products" style={{width: '100%'}} />
                </div>

            </section>

          </div>
        }
      </IonContent>
    </IonPage>
  );
};

export default QR17ChobaniLanding;
